import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React from "react";

export default class NomadBreadcrumbs extends React.Component {
  constructor(props) {
    super(props);

    this.state = { crumbs: [], currentLocation: "", loading: false };
  }

  componentDidMount() {
    this.refreshCrumbs();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.folderId !== prevProps.folderId ||
      this.props.searchTerm !== prevProps.searchTerm
    ) {
      this.refreshCrumbs();
    }
  }

  async refreshCrumbs() {
    if (!this.props.folderId) return;
    if (this.props.searchTerm) {
      this.setState({
        crumbs: [],
        currentLocation: `Search results for "${this.props.searchTerm}"`,
      });
      return;
    }

    this.setState({ loading: true });

    const response = await axios.get(
      `${this.props.nomadApiUrl}/api/asset/${this.props.folderId}/detail`,
      {
        headers: {
          Authorization: `Bearer ${this.props.token}`,
        },
      }
    );

    const detail = response && response.data;
    if (detail) {
      this.setState({
        crumbs:
          detail.parents &&
          detail.parents.filter(
            (parent) => parent.assetType === 1 && parent.displayName != null
          ),
        currentLocation: detail.properties.displayName,
      });
    }
    this.setState({ loading: false });
  }

  render() {
    const { crumbs: breadcrumbs, currentLocation } = this.state;
    return this.state.loading ? (
      <div className="nomad-breadcrumbs">Loading...</div>
    ) : (
      <div className="nomad-breadcrumbs">
        {this.props.searchTerm && (
          <div
            className="button returnButton"
            title="Return to folder view"
            onClick={this.props.clearSearch}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </div>
        )}
        {breadcrumbs &&
          breadcrumbs.map((breadcrumb) => (
            <div
              key={breadcrumb.id}
              className="breadcrumb"
              data-id={breadcrumb.id}
              onClick={this.props.navigateToFolder}
            >
              {breadcrumb.displayName}
            </div>
          ))}
        {currentLocation && (
          <div className="breadcrumb breadcrumb-current">{currentLocation}</div>
        )}
      </div>
    );
  }
}
